export const SERVICE_KEY = 'payments-api';
export var CustomerTypes;
(function (CustomerTypes) {
    CustomerTypes["SMB"] = "SMB";
    CustomerTypes["IDW"] = "IDW";
})(CustomerTypes || (CustomerTypes = {}));
//# sourceMappingURL=constants.js.map